export default __webpack_public_path__ + "static/favicon-4d7f5ff60cb80d3851e1e9a8829b0f0c.png";